import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { assetGroupSchema as schema } from '../../_validationSchema';
import { assetGroupAction as actions } from '../../_action/assetGroup.action';
import { assetGroup_model as model } from '../../_model';
import {
  assetGroupConstants as constants,
  assetSubClassConstants as subclass_constants,
} from '../../_constants';

import { useSelector } from 'react-redux';

const AssetGroup = (props) => {
  const { t } = props;

  const header = { name: 'AssetGroup', icon: 'cubes' };
  const reducer = useSelector((state) => state.assetGroupOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'asset-group';
  const menuCode = 'M_ASSET_GRP';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Description' },
    { title: t('assetSubClass'), field: 'AssetSubClass' },
  ];
  let useService = () => {
    return [schema, actions, model, constants, subclass_constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(AssetGroup);
